import axios from "axios";
import { Fragment, useEffect, useState } from "react"
import "./Home.css";
import "./card.css"
import Handmadegifts from "./Handmade";
import Metadata from "./Metadata";
import { useDispatch, useSelector } from "react-redux";
import Homehmadeslice from "../store/Homemadeslice";
import Loader from "./Loader";



const Homehmade = () => {
    const dispatch = useDispatch();
    const homemadevalue = useSelector((store) => {
        return store.homemade.products

    })
    const loader = useSelector((store) => {
        return store.homemade.loading

    })


    useEffect(() => {
        dispatch(Homehmadeslice.actions.productsrequest())
        axios.get("https://retoolapi.dev/RPi8Gq/data")
            .then(response => dispatch(Homehmadeslice.actions.productssuccess(response.data)))
            .catch(err => console.log(err))


    }, []);


    return (
        <Fragment>
            {loader ? <Loader> </Loader> :
                <div className="frames">
                    <Metadata title={"Handmade-Leegifts"}> </Metadata>

                    {homemadevalue.map((ele, idx) => {
                        return (
                            <Handmadegifts key={idx} img={ele.img} title={ele.title} price={ele.price} element={ele} id={ele.id} num={ele.num}> </Handmadegifts>
                        )
                    })}


                </div>}
        </Fragment>

    )


}
export default Homehmade;